export const CARD_IDS = [
  'destroy',
  'swap',
  'observe',
  'execute',
  'reincarnate',
  'gravity',
  'buoyancy',
  'attraction',
  'reinforcement',
  'wind',
] as const;

export type CardId = (typeof CARD_IDS)[number];

export type CardDefinition = Readonly<{
  id: CardId;
  name: string;
  description: string;
  cost: number;
}>;

export const PRODUCTION_CARDS: readonly CardDefinition[] = Object.freeze([
  { id: 'destroy', name: '破壊の意志', description: '直前に置いたキャラを破壊する。', cost: 3 },
  { id: 'swap', name: '入替の意志', description: '現在のキャラと次に来るキャラを交換する。', cost: 1 },
  { id: 'observe', name: '観測の意志', description: '30秒間、その次のキャラまで表示する。', cost: 2 },
  { id: 'execute', name: '執行の意志', description: '次に来るキャラを1体消す。', cost: 2 },
  { id: 'reincarnate', name: '転生の意志', description: '現在のキャラを別のキャラに変える。', cost: 2 },
  { id: 'gravity', name: '重力の意志', description: '現在のキャラの重さを2倍にする。', cost: 2 },
  { id: 'buoyancy', name: '浮力の意志', description: '直前のキャラを5秒間浮かせる。', cost: 3 },
  { id: 'attraction', name: '引力の意志', description: '直前のキャラを現在のキャラへ引き寄せる。', cost: 3 },
  { id: 'reinforcement', name: '増援の意志', description: 'ランダムなキャラを即座に落とす。', cost: 2 },
  { id: 'wind', name: '強風の意志', description: '現在のキャラを着地時に押す。', cost: 2 },
]);

export function getCard(cardId: CardId): CardDefinition {
  const card = PRODUCTION_CARDS.find((candidate) => candidate.id === cardId);
  if (!card) throw new Error(`Unknown card: ${cardId}`);
  return card;
}
